import { omdApi } from '../api';
import { getLoginUrl, getLogoutUrl } from '../../utils/auth-mode';

import { ChangePassword, Login, LoginAuth } from './types';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<Login, LoginAuth>({
      query: (data) => ({
        url: getLoginUrl(),
        method: 'POST',
        body: data,
      }),
    }),
    getChangePassword: builder.mutation<void, ChangePassword>({
      query: (data) => ({
        url: '/v1/login/ChangePassword',
        method: 'POST',
        body: data,
      }),
    }),
    logOut: builder.mutation<void, ChangePassword>({
      query: (data) => ({
        url: getLogoutUrl(),
        method: 'POST',
        body: data,
      }),
    }),
    getClaims: builder.query<string[], void>({
      query: () => ({
        url: '/v1/Login/claims',
      }),
    }),
  }),
});

export const { useLoginMutation } = request;
